import React, { useState, useCallback, useContext } from 'react'
import {useHistory} from "react-router-dom"
import Header from './header'
import IconNav from './iconNav'
import Button from './button'
import Radio from './radio'

import Input from './input'

import './button.css'
import DrivingItinerary from './drivingItinerary'
import Subheader from './subheader'
import CalculatorContext from '../Context'


function Driving() {
  const context = useContext(CalculatorContext);
  const {setCarMiles} = context;
  const history = useHistory();
  const selected = window.calculator_options.is_big_sky === false ? 1 :context.selectedDriving;
  const setSelected = context.setSelectedDriving;
  const itineraries = context.drivingItineraries;
  const setItineraries = context.setDrivingItineraries;
  
  const divingOrNot =[
    {
      text: "BZN Airport to Big Sky Resort Only",
      value: false
    },
    {
      text: "Enter my driving details below",
      value: true
    }
  ]

  const calculate= useCallback( (newItineraries, recalculate=true)=>{
    if(!recalculate){
      return setCarMiles(103.24);
    }
    const totals = newItineraries.reduce((prev, it)=>{  
       
      return prev + it.distance
    },0)
    
    setCarMiles(totals)
  }, [setCarMiles])

  const addNewItinerary = useCallback( () =>{
    const newItineraries = itineraries.slice()
    newItineraries.push({
      fromDriving: {name:"", id:""},
      toDriving: {name:"", id:""},
      distance: 0,
      invalid: 1,
      driveType: 0
    })
    setItineraries(newItineraries)
  }, [itineraries, setItineraries]);

  const deleteItinerary =useCallback((index)=>{    
    const newItineraries = itineraries.slice()
    newItineraries.splice(index,1)
    setItineraries(newItineraries)
    calculate(newItineraries)
  },[itineraries,calculate,setItineraries])

  const changeItinerary = useCallback((index,value, recalculate=true)=>{
    const newItineraries = itineraries.slice()
    newItineraries.splice(index,1,value)
    setItineraries(newItineraries)    
    if(recalculate){
      calculate(newItineraries)
    }
  }, [itineraries, calculate, setItineraries])
  return (
    <div className="driving">
      <Subheader>
        Driving
      </Subheader>
      {window.calculator_options.is_big_sky?(
        <Radio selected={selected} options={divingOrNot} onChange={(i)=>{setSelected(i); calculate(itineraries, i==1)}}/>
      ):<div className="driving-subheader">
          {divingOrNot[1].text}
        </div>
      }
      {selected ==1 && itineraries.map((itinerary, index)=>
        <DrivingItinerary index={index} itinerary={itinerary} onChange={changeItinerary} onDelete={deleteItinerary}/>
      )}
      {selected ==1 && (
        <div className="small-tip">
          Need to add additional routes or stops?
        </div>
      )}
      {selected ==1 && (
      <div className="buttons">
        <Button className="initial-button primary another" onClick={addNewItinerary}>
          ADD ANOTHER ITINERARY
        </Button>
      </div>
      )}
      <div className="buttons ">        
        <Button showImage={false} className="primary initial-button" onClick={()=>history.push('/flights') }>
          BACK
        </Button>
        <Button className="primary initial-button" onClick={()=>history.push('/lodging') }>
          NEXT
        </Button>        
      </div>
    </div>
  )
}

export default Driving